import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=6fb09b5c"
import script from "./LanguagesList.vue?vue&type=script&lang=js"
export * from "./LanguagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports